import { MAX_TABS } from '../../../constants/common.constants';
export var createTabs = function (shops) {
    return Array.from({ length: MAX_TABS }, function (_, index) {
        var shop = shops === null || shops === void 0 ? void 0 : shops[index];
        return {
            index: index,
            shop: shop,
            label: shop ? shop.domain : "shop.tab.".concat(index + 1),
            isEmpty: !shop,
        };
    });
};
